import type { WalletConnectParameters } from '@wagmi/connectors'

export const defaultWalletConnectConfig: WalletConnectParameters = {
  projectId: '5432e3507d41270bee46b7b85bbc2ef8',
}
